<template>
  <v-select
    v-model="selected"
    label="Reason"
    :items="reasonsRefund"
    :prepend-icon="icon ? 'mdi-comment-text-outline' : ''"
    clearable
    :dense="dense"
    item-text="name"
    item-value="name"
    :outlined="outlined"
    :class="{ 'search-input': hideDetails }"
    :rules="rules"
  />
</template>

<script>
import { reasonsRefund } from "./data/reasons-refund";
export default {
  name: "SelectReasonsRefund",
  props: {
    hideDetails: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    selected: null,
    reasonsRefund: reasonsRefund,
  }),
  watch: {
    selected: function () {
      this.$emit("input", this.selected);
    },
  },
};
</script>
